import React from 'react'
import TextBox from '../../../../../../../common/components/molecule/TextBox/TextBox'

export interface PoleNumberViewPrope {
    number?: string
}
export default function PoleNumberView( {number}: PoleNumberViewPrope) {
  return (
    <TextBox variant='dark' content={[{
        title: 'Numéro',
        text: number
    }]}/>
  )
}
